import { randomString } from '../mockUtils'
const CUSTOM_TAG = (args: { categoryKey: string; prefix: string }) => ({
  key: `${args.prefix}${randomString({ length: 3 })}`,
  lang: 'sv',
  categoryKey: args.categoryKey,
})

export default CUSTOM_TAG
